import Amplitude from "amplitude-js";

const amplitudeClient = Amplitude.getInstance();

let userId: string = null;
let clientId: string = null;
let planName: string = null;
let authenticator: string = null;

let useAnalyticsAPI = false;

// @ts-ignore need to do this because we comment out the key in config
if (site["analyticsAPIKey"]) {
  useAnalyticsAPI = true;
  // @ts-ignore
  amplitudeClient.init(site["analyticsAPIKey"]);
} else {
  // @ts-ignore
  amplitudeClient.init("FAKEAPIKEY", null, site["amplitudeConfig"]);
  useAnalyticsAPI = true;
}

export const setAnalyticsUserId = (id: string): void => {
  if (useAnalyticsAPI) {
    amplitudeClient.setUserId(id);
    userId = id;
  }
};

export const setAnalyticsEligibilityInfo = (id: string, name: string): void => {
  if (useAnalyticsAPI) {
    clientId = id;
    planName = name;
  }
};

export const setAnalyticsAuthenticator = (auth_type: string): void => {
  if (useAnalyticsAPI) {
    authenticator = auth_type;
  }
};

export const logEvent = (eventName: string, params?: object): void => {
  if (useAnalyticsAPI) {
    amplitudeClient.setUserProperties({ client_id: clientId, plan_name: planName });
    amplitudeClient.logEvent(eventName, {
      ...params,
      userId: userId,
      clientID: clientId,
      authenticator: authenticator,
    });
  }
};

export const ANALYTIC_EVENTS = {
  ACCOUNT: {
    beforeCreate: "going to create cognito user",
    create: "create account successful",
    validate: "validate member success",
  },
  DESKTOP_SIDE_NAV: "top nav side menu clicked",
  EXTERNAL_CONNECTION: "external connection launch",
  EXTERNAL_CONNECTIONS: {
    topNav: "externalLink_side_nav",
  },
  SIGN_OUT_BUTTON: "sign out button clicked",
  DASHBOARD_NAV: "dashboard link clicked",
  DOCUMENTS: {
    download: "download document PDF",
    dependentFilterChange: "document list dependent filter change",
  },
  FOOTER_MENU: {
    myRx: "my_rx_bottom_nav",
    findBestPrice: "fbp_bottom_nav",
    claimsHistory: "history_bottom_nav",
    nearByPharmacies: "nearby_pharm_bottom_nav",
  },
  LOGIN: {
    success: "successful login",
    ssoSuccess: "successful sso login",
    failure: "failed login attempt",
    ssoFailure: "failed sso login attempt",
    challenge: "challenge login success",
    migrationNotification: "migration notification success",
  },
  MY_RX: {
    topNav: "myRx_top_nav",
    individual: "toggle individual - my rx",
    family: "toggle family - my rx",
    individualWidget: "toggle individual widget - my rx",
    familyWidget: "toggle family widget - my rx",
    inNetwork: "toggle in network - my rx",
    outOfNetwork: "toggle out of network - my rx",
    ACCUMULATOR: {
      deductible: {
        viewed: "deductible viewed",
        seeSpent: "see spent - deductible",
        seeRemaining: "see remaining - deductible",
      },
      outOfPocket: {
        viewed: "out of pocket viewed",
        seeSpent: "see spent - out of pocket",
        seeRemaining: "see remaining - out of pocket",
      },
      planSpend: {
        viewed: "plan spend viewed",
        seeSpent: "see spent - plan spent",
        seeRemaining: "see remaining - plan spent",
      },
    },
  },
  MPPP: {
    MY_RX: {
      learnMore: "learn more button clicked - my rx mppp",
      optIn: "opt in button clicked - my rx mppp",
    },
    CALCULATOR: {
      calculate: "payment calculator form submitted",
    },
    OPT_IN_FORM: {
      optIn: "user opted in - mppp",
    },
    PAYMENT_INFORMATION: {
      changePaymentInformation: "user changed payment information - mppp",
    },
  },
  APP_MENU_ITEMS: {
    topNav: "dynamicLink_side_nav",
  },
  PRESCRIPTION: {
    backButton: "prescription details back",
    findLowestPriceButton: "prescription details find lowest price",
  },
  FIND_BEST_PRICE: {
    topNav: "findbestprice_top_nav",
    backButton: "fbp back button",
    pagination: {
      pageNumber: "fbp page -",
    },
    sortPrice: "fbp sort price",
    sortDistance: "fbp sort distance",
    resultItems: "fbp results item",
    resultRejectedItems: "fbp results rejected item",
    redoSearchBar: "fbp redo search bar",
    redoSearchMap: "fbp redo search in map",
    selectedPharmacy: "find best price result",
  },
  CLAIM_DETAILS: {
    printMedicalClaimDetails: "medical claims details pdf",
    printPharmacyClaimsDetails: "pharmacy claims details pdf",
  },
  CLAIM_HISTORY: {
    topNav: "claimHistory_top_nav",
    backButton: "claims history back button",
    deliveryNetworkRedirect: "claims history refill button",
    lookupCurrentPrice: "claims history check current price",
    searchHistory: "search claims history",
    viewClaim: "claims history view claim",
    pagination: {
      pageNumber: "claims history page -",
    },
    printMedicalClaimsHistory: "print medical claims history summary",
    generateMedicalClaimsHistory: "generate medical claims history",
    printPharmacyClaimsHistory: "print pharmacy claims history summary",
    generatePharmacyClaimsHistory: "generate pharmacy claims history",
    toggleMedical: "claims history toggle medical",
    togglePharmacy: "claims history toggle pharmacy",
    toggleDental: "claims history toggle dental",
    toggleVision: "claims history toggle vision",
    dependentFilterChange: "claims history dependent filter change",
    serviceDateFilterChange: "claims history service date filter change",
    pageView: "claims history page view",
    statusFilterChange: "claims history status filter change",
    statusFilterClear: "claims history status filter clear",
    mpppCheckboxToggle: "claims history mppp checkbox toggle",
    serviceDateClear: "claims history service date clear",
    searchClear: "claims history search clear",
  },
  PRIOR_AUTHORIZATION: {
    topNav: "priorAuthorization_top_nav",
    backButton: "prior authorizations back button",
    viewCase: "prior authorization view case",
    pagination: {
      pageNumber: "prior authorization list page -",
    },
    searchPriorAuthorization: "prior authorization search",
    printPage: "print prior authorization page",
  },
  ELIGIBILITY: {
    topNav: "eligibility_top_nav",
  },
  CARE_USAGE_AND_LIMITS: {
    topNav: "care_usage_and_limits_top_nav",
    dependentFilterChange: "care usage dependent filter change",
    searchCare: "search care usage",
    pageView: "care usage and limits page view",
  },
  MEMBER_ID_CARD: {
    topNav: "member_id_card_top_nav",
  },
  MEDICARE_PRESCRIPTION_PAYMENT_PLAN: {
    topNav: "medicare_prescription_payment_plan_top_nav",
  },
  DMR: {
    topNav: "dmr_top_nav",
  },
  FORMS_AND_DOCUMENTS: {
    topNav: "formsAndDocuments_side_nav",
  },
  NEARBY_PHARMACIES: {
    topNav: "nearbyPharmacy_side_nav",
  },
  PLAN_CONTRIBUTIONS: {
    topNav: "planContributions_top_nav",
  },
  PRFERENCES: {
    topNav: "notifications_side_nav",
  },
  FORMULARY: {
    topNav: "lookup_formulary_side_nav",
  },
  INBOX: {
    dependentFilterChange: "inbox dependent filter change",
    topNav: "inbox_top_nav",
    LOW_COST_ALTERNATIVE: {
      lcaMessageOpen: "lca message opened",
      lcaMessageDelete: "lca message deleted",
      viewClaimMessage: "message related claim viewed",
    },
    ADHERENCE: {
      adhMessageOpen: "adh message opened",
      adhMessageDelete: "adh message deleted",
    },
  },
  ERRORS: {
    drugList: "drug list fetch fail",
    drugSingle: "single drug fetch fail",
    drugPrice: "drug price fetch fail",
    setSelectedDrugPrice: "set selected drug price fetch fail",
    getSelectedDrugPrice: "get selected drug price fetch fail",
    getLocationAndDrugPrices: "get location and drug price fetch fail",
    validateToken: "validate token fetch fail",
    verifyUser: "verify member fetch fail",
    getUserCurrentLocation: "get member current location fetch fail",
    getMemberInputLocation: "get member input location fetch fail",
    getMemberAccumulation: "get member accumulation fetch fail",
    getMemberClaimsHistory: "get member claims history fetch fail",
    getMemberClaimsById: "get member claims by id fetch fail",
    getMemberEarliestClaim: "get member earliest claim fetch fail",
    getMemberClaimsByDate: "get member claims by date fetch fail",
    getMemberDocuments: "get member document fetch fail",
    getPlanDocuments: "get plan document fetch fail",
    getMemberDocumentUrl: "get member document url fetch fail",
    getPlanDocumentUrl: "get member document url fetch fail",
    getPriorAuthorizationDocumentsUrl: "get prior authorization document url fetch fail",
    getMemberEligibilityInfo: "get member eligibility info fetch fail",
    getPharmacyDetails: "get pharmacy details fetch fail",
    getPharmacyList: "get pharmacy list fetch fail",
    getLocationAndPharmacyList: "get location and pharmacy list fetch fail",
    navigateLocationAndPharmacyList: "navigate location and pharmacy list fetch fail",
    getSelectedPharmacy: "get selected pharmacy fetch fail",
    loadAmplify: "amplify configuration load fail",
    registerMember: "register member fail",
    validateMember: "validate member fail",
    loginChallenge: "login challenge failed",
    migrationNotification: "migration notification failed",
    userPreferences: "user preferences get fail",
  },
};
